/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-06 09:57:44                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2024-12-02 12:55:38                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Interfaces
  * WorkordersStatusDisplay: workorder status display component
*/

/* Imports */
import { Chip, Tooltip } from "@material-tailwind/react";
import { t } from "i18next";
import { getWorkorderStatusStyle } from "./workorderStatusStyles";
/***/

/* Interfaces */
import { WorkorderStatus } from "../../../types/workorder/workorderStatus";
/***/

/**
* WorkordersStatusDisplay: workorder status display component
* Used to display a workorder status
* All status have a color associated 
* @param status - status value
* @param size - size options
*/
export default function WorkordersStatusDisplay(props: {
  status: WorkorderStatus,
  size?: "sm" | "md" | "lg",
  iconOnly?: boolean
}) {
  const size = props.size ? props.size : "md";
  const textSize = size === "sm" ? "xs" : size === "md" ? "xs" : "base";
  const label = t("workorder:status." + props.status.toLowerCase());
  const style = getWorkorderStatusStyle(props.status);
  const StatusIcon = style.icon;

  if (props.iconOnly) {
    return (
      <Tooltip content={label}>
        <span className="et-cell-icon-badge text-white" style={{ backgroundColor: style.solid }}>
          <StatusIcon className="h-4 w-4" />
        </span>
      </Tooltip>
    );
  }

  return (
    <Chip variant="ghost"
      size={size}
      value={label}
      className={"w-fit h-fit rounded-full py-1 normal-case text-" + textSize}
      style={{ backgroundColor: style.soft, color: style.text }} />
  );
}
/***/
